// 配色提取
export const primaryColor = "var(--primary-color)";
export const primaryLighterColor = "var(--primary-lighter-color)"
export const primaryColorHover = "var(--primary-color-hover)"
export const inputActiveShadowColor = "var(--input-active-shadow-color)"
export const radioButtonBgColor ="var(--radio-button-bg-color)"
export const primaryFontColor = "var(--primary-font-color)"